import React from 'react';
import { Redirect, Route, Switch, asyncComponent } from '../../../components';

const PurolatorFees = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/import`} />
            <Route path={`${match.url}/import`} component={asyncComponent(() => import('./routes'))} />
            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))} />
        </Switch>
    </div>
);

export default PurolatorFees;